import { ChangeDetectorRef, Component, Inject, Injector, INJECTOR, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { NanoService } from 'src/app/shared/nano/nano.service';
import {
  PrivyRoomRecord,
  RoomWithData,
} from 'src/app/shared/server-services/query-records/room-records';
import { RoomService } from 'src/app/shared/server-services/room.service';
import { DialogService } from 'src/app/shared/services/dialog.service';
import { NanoDialogBaseComponent } from '../../nano-base-dialog';
import { SafeRadix32 } from '../../../safe-radix32';

@Component({
  selector: 'app-admin-add-backup-dialog',
  templateUrl: './admin-add-backup-dialog.component.html',
  styleUrl: './admin-add-backup-dialog.component.scss',
})
export class AdminAddBackupDialogComponent
  extends NanoDialogBaseComponent<AdminAddBackupDialogComponent>
  implements OnInit
{
  form = new FormGroup({
    room_id: new FormControl('', { validators: [Validators.required] }),
  });

  public allRooms: RoomWithData[] = [];
  public allPrivyRooms: (PrivyRoomRecord & { info?: { name; version } })[] = [];

  constructor(
    private roomService: RoomService,
    @Inject(INJECTOR) injector: Injector,
    private nanoService: NanoService,
    private cd: ChangeDetectorRef, //@Inject(MAT_DIALOG_DATA) public data,
    private dialogService: DialogService
  ) {
    super(injector);
    roomService.getAllRoom().then((rooms) => {
      this.allRooms = <RoomWithData[]>rooms;
    });
    roomService.getPrivyRooms().then((rooms) => {
      rooms
        .filter((privy) => privy.lastActive && privy.sessionId)
        .forEach((r) => {
          r['isPrivy'] = true;
          this.nanoService.privyGetInfo(
            r,
            (info) => {
              console.log('info', info);
              r['info'] = info;
              this.cd.detectChanges();
            },
            (err) => {
              console.log('could not load privy room info', err);
              this.cd.detectChanges();
            }
          );
        });
      this.allPrivyRooms = rooms;
    });
  }

  ngOnInit(): void {}

  public addBackup() {
    this.dialogRef.close(this.form.value);
  }

  public visibilityChangeOnRoom(roomId) {
    this.roomService.getRoom(roomId).then(() => {
      this.cd.detectChanges();
    });
  }

  public selectedRoom;
  public selectRoom(room) {
    this.form.get('room_id').setValue(room.roomId || room.id);
    this.selectedRoom = room;
  }

  public deletePrivy(roomId) {
    this.dialogService
      .openConfirmDialog(
        marker('Are you sure?'),
        marker('Are you sure you want to delete this Backup Agent?'),
        marker('Delete'),
        marker('Cancel')
      )
      .subscribe((res) => {
        if (!res) return;

        this.roomService
          .deletePrivyRoom(roomId)
          .then((res) => {
            console.log('res', res);
            let ind = this.allPrivyRooms.findIndex((r) => r.roomId == roomId);
            if (ind > -1) {
              this.allPrivyRooms.splice(ind, 1);
              this.cd.detectChanges();
            }
            this.selectedRoom = undefined;
          })
          .catch((err) => {
            console.log('err', err);
            this.dialogService.openAlertDialog(
              marker('Backup Agent delete failed'),
              marker('Error happened during the process')
            );
          });
      });
  }

  // TODO: this is duplicated 3 times in the code, put them all to a good utility module
  public getTimeFromId(id: string): Date {
    let ticks = SafeRadix32.decodeSafeRadix32(id.slice(0, -5)); // get the ticks from the encoded number
    let timestamp = ticks * 20; // 0.02 sec for every tick
    return new Date(timestamp + 1577836800000); // add 2020.01.01 01:00 to it (this is the start)
  }
}
